"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (prefix = '') => {
  return [_path || (_path = _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.999 12l8 8 1.414-1.413L7.827 13H20v-2H7.827l5.587-5.587L12 4l-8.001 8z"
  }))];
};

exports.default = _default;